import { QueryErrorBoundary } from '@sara/ui/components/query-error-boundary';
import { InterviewListContainerContent } from './InterviewListContainerContent';
import type { InterviewListContainerProps } from './types';

export function InterviewListContainer(props: InterviewListContainerProps) {
  return (
    <QueryErrorBoundary>
      <InterviewListContainerContent {...props} />
    </QueryErrorBoundary>
  );
}
